module.exports = __webpack_public_path__ + "images/TransMedics-ab42a2.png";